module.exports = __webpack_public_path__ + "img/inactive-employees.c4545564.png";